/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Tasks = Loadable(lazy(() => import("sections/tasks")));

const taskRoutes = [
    {
        path: "tasks",
        element: <Tasks />,
        // children: []
    },
];
export { taskRoutes };
